import React from "react"
import * as utils from "../../../helpers/utils"
import { ETrendType, ETrendUnitType, ITrendSettingsDocument } from "../../../models/data/dashboard/Trends/TrendsData"

export interface IProps {
    value: number,
    settings: ITrendSettingsDocument
}

export default class TrendChangeChip extends React.Component<IProps, any> {    
    componentDidMount() {
    }

    componentDidUpdate() {
    }


    render() {
        const greenColor = utils.getTrendColorGreen() 
        const redColor = utils.getTrendColorRed()
        const greyColor = utils.getTrendColorGrey()

        let chipColor = greenColor; 
        if((this.props.settings.AggregationSettings.NegativeGrowthPreferred && this.props.value > 0) || (!this.props.settings.AggregationSettings.NegativeGrowthPreferred && this.props.value < 0)){
            chipColor = redColor
        } 
        
        if(this.props.value === 0){
            chipColor = greyColor
        }

        return (
            <div style={{backgroundColor: chipColor, borderRadius: 5, color: "#ffffff", padding: 5, width: 50, textAlign: "center"}}>
                {(this.props.value > 0 ? "+" : "")}{this.props.value}{this.props.settings.UnitType === ETrendUnitType.Percentage && <span style={{}}>%</span>}
            </div>
        )
    }
}